import React, { useEffect, useState, useMemo } from "react";

function AccountClassSetupScroll(props) {
    const [textInput, setTextInput] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

    // Debounce the search term
    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedSearchTerm(textInput);
        }, 500); // 500ms delay

        return () => {
            clearTimeout(timerId);
        };
    }, [textInput]);

    const filteredList = useMemo(() => {
        const list = props?.list || [];
        if (debouncedSearchTerm.length > 2) {
            return list.filter(account =>
                account.account_main_name.toLowerCase().includes(debouncedSearchTerm.toLowerCase()) ||
                account.account_type_name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
            );
        }
        return list;
    }, [props?.list, debouncedSearchTerm]);


    const handleInputChange = (e) => {
        setTextInput(e.target.value);
    };

    return (
        <>
            <div className="w-64 h-screen overflow-y-auto border border-black p-4">
                {/* Search Input */}
                <input
                    type="text"
                    placeholder="Search..."
                    className="w-full mb-4 p-2 border border-gray-300 rounded"
                    value={textInput}
                    onChange={handleInputChange}
                />
                <ul className="space-y-2">
                    {filteredList?.map((type, index) => {
                        return (
                            <li 
                                onClick={() => props.onSelectedItem(type)} 
                                key={index} 
                                className="p-2 bg-blue-50 border border-gray-300 rounded hover:bg-gray-100 cursor-pointer"
                            >
                                <span>{type?.account_type_name}</span> <br/>
                                <small className="p-1 m-2 text-left font-bold bg-gray-50">{type?.account_main_name}</small>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </>
    );
}

export default AccountClassSetupScroll;